<template>
  <div class="container">
    <h1>音书科技</h1>
    <div class="error">
      <Icon type="error" />
    </div>
    <p class="reason">
      音书网页版已升级为字幕速记系统，只针对企业级用户开放，您尚未获得相应权限。
    </p>
    <p class="tip">
      如果您需要获得本服务，请联系音书科技销售人员，联系方式如下：
    </p>
    <div class="aboutme">
      <div class="aboutme-row">
        <div class="aboutme-icon">
          <Icon type="telephone" />
        </div>
        <div class="aboutme-info">
          座机电话：020-28190864
        </div>
      </div>
      <div class="aboutme-row">
        <div class="aboutme-icon">
          <Icon type="email" />
        </div>
        <div class="aboutme-info">
          邮箱：bd@voibook.com
        </div>
      </div>
      <div class="aboutme-row">
        <div class="aboutme-icon">
          <Icon type="qq" />
        </div>
        <div class="aboutme-info">
          商务合作QQ：1956033634
        </div>
      </div>
      <div class="aboutme-row">
        <div class="aboutme-icon">
          <Icon type="group" />
        </div>
        <div class="aboutme-info">
          官方QQ群：160359433
        </div>
      </div>
      <div class="aboutme-row">
        <div class="aboutme-icon">
          <Icon type="wechat" />
        </div>
        <div class="aboutme-info">
          微信公众号“音书社区”
        </div>
      </div>
      <div class="aboutme-row">
        <div class="er-code">
          <Icon type="er-code" />
        </div>
      </div>
      <div class="aboutme-row" style="text-align: center;">
        扫一扫，关注我哦~
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon'
export default {
  name: 'nopay',
  components: {
    Icon
  }
}
</script>

<style scoped="scoped">
div {
  position: relative;
}
.container {
  margin: 20px auto 0 auto;
  text-align: left;
  color: #111;
  width: 510px;
  word-break: break-all;
}
.container h1 {
  color: #777;
  text-align: center;
}
.container .error {
  width: 180px;
  height: 135px;
  margin: auto;
}
.container .aboutme {
  margin: auto;
  width: 235px;
  font-size: 15px;
}
.container .aboutme .aboutme-row>* {
  display: inline-block;
  line-height: 30px;
  vertical-align: middle;
  height: 30px;
}
.container .aboutme .aboutme-icon {
  width: 30px;
  height: 30px;
}
.container .aboutme .er-code {
  width: 130px;
  height: 130px;
  margin: auto;
  display: block
}
</style>



// WEBPACK FOOTER //
// src/pages/Nopay.vue